export default __webpack_public_path__ + "static/media/completeIcon.d8c39080.svg";